"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputTokenBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_input_token_constants_1 = require("./bc-input-token-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var BcInputTokenBehavior = (function (_super) {
    __extends(BcInputTokenBehavior, _super);
    function BcInputTokenBehavior() {
        var _this = _super.call(this) || this;
        _this.previousValue = '';
        _this.previousStatus = '';
        _this.setupIsDone = false;
        _this.inputStatus = false;
        _this.isValid = false;
        _this.nextValue = '';
        _this.value = '';
        _this.errorMessage = '';
        _this.infoMessage = '';
        return _this;
    }
    BcInputTokenBehavior.setUpAll = function () {
        var inputElements = Array.from(document.querySelectorAll("div[class~='".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN, "']")));
        var elements = [];
        for (var _i = 0, inputElements_1 = inputElements; _i < inputElements_1.length; _i++) {
            var element = inputElements_1[_i];
            var bcInputTokenBehavior = new BcInputTokenBehavior();
            bcInputTokenBehavior.setElement(element);
            bcInputTokenBehavior.setUp();
            elements.push(bcInputTokenBehavior);
        }
        return elements;
    };
    BcInputTokenBehavior.prototype._setUp = function () {
        _super.prototype._setUp.call(this);
        this.validateElementContainer();
        this.setSettings();
        this.createTokenInputs();
        this.createLabel();
        this.changeStatus(this.status);
        this.initialFocus();
        this.validateInitialFocus();
        this.preventCopyCutPaste();
        this.setupIsDone = true;
    };
    BcInputTokenBehavior.prototype.getAttributeHTML = function (divContainer, attributeName, defaultValue) {
        var attribute = divContainer.getAttribute(attributeName);
        return attribute ? attribute : defaultValue;
    };
    BcInputTokenBehavior.prototype.getElementContainer = function () {
        return this.mySelf.querySelector(".".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_CONTAINER));
    };
    BcInputTokenBehavior.prototype.setSettings = function () {
        if (!this._id) {
            this._id = this.generateId();
        }
        if (!this.status) {
            this.status = this.getAttributeHTML(this.mySelf, 'status', 'default').toLowerCase();
        }
        var tokenInputContainer = this.getElementContainer();
        if (!this.numInputs) {
            this.numInputs = parseInt(this.getAttributeHTML(tokenInputContainer, 'num-inputs', '6'));
        }
        if (!this.isUnmasked) {
            var unmasked = this.getAttributeHTML(tokenInputContainer, 'unmasked', 'false');
            this.isUnmasked = unmasked.toLowerCase() === 'true' ? true : false;
        }
        if (!this.showInfoMessage) {
            var showMsgs = this.getAttributeHTML(tokenInputContainer, 'show-info-message', 'true');
            this.showInfoMessage = showMsgs.toLowerCase() === 'false' ? false : true;
        }
    };
    BcInputTokenBehavior.prototype.generateId = function () {
        var prefix = 'input-token';
        var array = new Uint32Array(1);
        var randomNumber = window.crypto.getRandomValues(array);
        return "".concat(prefix, ".").concat(randomNumber[0]);
    };
    BcInputTokenBehavior.prototype.validateElementContainer = function () {
        var container = this.getElementContainer();
        if (!container) {
            var divContainer = document.createElement('div');
            divContainer.classList.add(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_CONTAINER);
            this.mySelf.append(divContainer);
        }
    };
    BcInputTokenBehavior.prototype.createTokenInputs = function () {
        for (var i = 1; i <= this.numInputs; i++) {
            var input = document.createElement('input');
            var valor = "^[0-9]$";
            input.setAttribute('pattern', valor);
            var id = "".concat(this._id, "-").concat(i);
            input.setAttribute('id', id);
            input.setAttribute('class', bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_CLASS);
            input.setAttribute('required', 'true');
            input.setAttribute('placeholder', ' ');
            input.setAttribute('aria-label', bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_MESSAGE_INPUT.replace('[NUM]', this.getPositionLabel(i)));
            if (this.isUnmasked) {
                input.setAttribute('type', 'number');
            }
            else {
                input.setAttribute('type', 'password');
            }
            this.addEventsInput(input, i);
            this.getElementContainer().appendChild(input);
        }
    };
    BcInputTokenBehavior.prototype.getInfoMessage = function () {
        if (!this.showInfoMessage) {
            return '';
        }
        this.infoMessage = this.getAttributeHTML(this.getElementContainer(), 'info-message', '');
        return (this.infoMessage.length !== 0 ? this.infoMessage : bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_MESSAGE_NUMBER_INPUTS).replace('[NUM_INPUTS]', this.numInputs.toString());
    };
    BcInputTokenBehavior.prototype.getErrorMessage = function () {
        this.errorMessage = this.getAttributeHTML(this.getElementContainer(), 'error-message', '');
        return this.errorMessage.length !== 0 ? this.errorMessage : bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_MESSAGE_REQUIRED;
    };
    BcInputTokenBehavior.prototype.removeError = function () {
        this.getElementContainer().classList.remove("".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_ALL_INPUTS_ERROR));
        var labelBottom = this.mySelf.querySelector("label[class~='".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_LABEL_BOTTOM, "']"));
        labelBottom.innerText = this.getInfoMessage();
    };
    BcInputTokenBehavior.prototype.putError = function () {
        this.getElementContainer().classList.add("".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_ALL_INPUTS_ERROR));
        this.removeValid();
        var labelBottom = this.mySelf.querySelector("label[class~='".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_LABEL_BOTTOM, "']"));
        labelBottom.innerText = this.getErrorMessage();
        this.status = 'error';
    };
    BcInputTokenBehavior.prototype.putValid = function () {
        this.getElementContainer().classList.add("".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_ALL_INPUTS_VALID));
        this.removeError();
    };
    BcInputTokenBehavior.prototype.removeValid = function () {
        this.getElementContainer().classList.remove("".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_ALL_INPUTS_VALID));
    };
    BcInputTokenBehavior.prototype.removeInitialFocusClass = function () {
        this.getElementContainer().classList.remove("".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_CONTAINER_INITIAL_FOCUS));
    };
    BcInputTokenBehavior.prototype.validateInitialFocus = function () {
        var _this = this;
        setTimeout(function () {
            var input = _this.mySelf.querySelector("input[id='".concat(_this._id, "-1']"));
            if (input === document.activeElement) {
                _this.removeInitialFocusClass();
            }
        }, 1);
    };
    BcInputTokenBehavior.prototype.inputBlur = function () {
        if (!this.inputStatus) {
            var initialFocus = this.getElementContainer().classList.contains("".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_CONTAINER_INITIAL_FOCUS));
            if (!initialFocus) {
                this.putError();
            }
        }
        if (this.inputStatus && this.previousStatus === 'error' && this.value === this.previousValue) {
            this.changeStatus('error');
        }
    };
    BcInputTokenBehavior.prototype.inputFocus = function () {
        if (this.mySelf.querySelector("label[class~='".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_LABEL_BOTTOM, "']"))) {
            this.removeError();
        }
        var initialFocus = this.getElementContainer().classList.contains("".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_CONTAINER_INITIAL_FOCUS));
        if (initialFocus) {
            this.removeInitialFocusClass();
        }
        if (this.setupIsDone && this.status === 'error') {
            this.changeStatus('default');
        }
    };
    BcInputTokenBehavior.prototype.onInput = function (currentInput, id) {
        var input = currentInput.currentTarget;
        var maxLength = bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_MAX_LENGTH_INPUT;
        this.nextValue = '';
        if (input.value.length > maxLength) {
            if (id < this.numInputs) {
                this.nextValue = input.value.slice(1);
            }
            input.value = input.value.slice(0, maxLength);
        }
    };
    BcInputTokenBehavior.prototype.validateInputValues = function () {
        this.controlInputs();
        if (this.inputStatus) {
            this.putValid();
            this.changeValuesEmitEvent();
        }
        else {
            this.removeValid();
        }
        if ((!this.isValid && this.inputStatus) || (this.isValid && !this.inputStatus)) {
            this.isValid = this.inputStatus;
            this.changeStatus('default');
            this.changeStatusEmitEvent();
        }
    };
    BcInputTokenBehavior.prototype.getNextAvailable = function (currentInput) {
        var nextInput = -1;
        var container = this.mySelf.querySelectorAll("input[id^='".concat(this._id, "']"));
        var inputElements = Array.from(container);
        var index = 0;
        while (index < inputElements.length && nextInput < 0) {
            var element = inputElements[index];
            var valueInput = element.value;
            if (valueInput.length === 0 && index + 1 > currentInput) {
                nextInput = index + 1;
            }
            index++;
        }
        if (nextInput === -1) {
            nextInput = this.numInputs;
        }
        return nextInput;
    };
    BcInputTokenBehavior.prototype.validateValueOnNextInput = function (inputId) {
        if (this.nextValue.length > 0) {
            var input = this.mySelf.querySelector("input[id='".concat(this._id, "-") + inputId + "']");
            if (this.nextValue.length == 1 && !isNaN(Number(this.nextValue))) {
                input.value = this.nextValue;
                input.classList.add(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_FILLED);
                this.validateInputValues();
                var pId = this.getNextAvailable(inputId);
                this.findInput(pId).focus();
            }
            this.nextValue = '';
        }
    };
    BcInputTokenBehavior.prototype.inputkeyup = function (keyEvent, id) {
        var key = keyEvent.which;
        var pId = id;
        var input = this.mySelf.querySelector("input[id='".concat(this._id, "-") + id + "']");
        this.findInput(pId).blur();
        pId = this.inputKey(input, key, pId, id);
        var nextInput = this.findInput(pId);
        nextInput.focus();
        if (nextInput.value.length > 0) {
            var temporalValue = nextInput.value;
            nextInput.value = '';
            nextInput.value = temporalValue;
        }
        this.validateInputValues();
        this.validateValueOnNextInput(pId);
    };
    BcInputTokenBehavior.prototype.inputKey = function (input, key, pId, id) {
        if (input.value.toString().length === 0 && key === bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_BACK_SPACE_ASCII_CODE) {
            pId = id <= 1 ? 1 : id - 1;
            input.classList.remove(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_FILLED);
        }
        if (key === bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_DELETE_ASCII_CODE) {
            input.classList.remove(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_FILLED);
        }
        if (input.value.toString().length == 1 && this.isValidNumber(key)) {
            pId = this.getNextAvailable(id);
            input.classList.add(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_FILLED);
        }
        return pId;
    };
    BcInputTokenBehavior.prototype.isValidNumber = function (key) {
        var keyIsNumber = false;
        if ((key >= bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_ZERO_ASCII_CODE &&
            key <= bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_NINE_ASCII_CODE) ||
            (key >= bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_ZERO_ASCII_CODE_ALFA &&
                key <= bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_NINE_ASCII_CODE_ALFA)) {
            keyIsNumber = true;
        }
        return keyIsNumber;
    };
    BcInputTokenBehavior.prototype.findInput = function (id) {
        return this.mySelf.querySelector("input[id='".concat(this._id, "-") + id + "']");
    };
    BcInputTokenBehavior.prototype.validateNumbers = function (event, inputId) {
        var numericPattern = /^[0-9]*$/;
        if (!numericPattern.test(event.key)) {
            event.preventDefault();
        }
        var input = this.mySelf.querySelector("input[id='".concat(this._id, "-") + inputId + "']");
        var inputFilled = input.classList.contains(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_FILLED);
        var allInputsValid = this.getElementContainer().classList.contains("".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_ALL_INPUTS_VALID));
        var nextId = this.getNextAvailable(inputId);
        if ((inputFilled && inputId + 1 !== nextId) || allInputsValid) {
            event.preventDefault();
        }
    };
    BcInputTokenBehavior.prototype.validateOtherCharacters = function (event, inputId) {
        var _this = this;
        if (event.defaultPrevented) {
            return;
        }
        var numericPattern = /^[0-9]*$/;
        if (!numericPattern.test(event.key)) {
            setTimeout(function () {
                var input = _this.mySelf.querySelector("input[id='".concat(_this._id, "-") + inputId + "']");
                input.value = input.value.replace(/\D+/g, '');
            }, 0);
        }
    };
    BcInputTokenBehavior.prototype.getPositionLabel = function (index) {
        return bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_POSSITION_ARRAY.has(index)
            ? bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_POSSITION_ARRAY.get(index)
            : '';
    };
    BcInputTokenBehavior.prototype.addEventsInput = function (input, index) {
        var _this = this;
        input.addEventListener('keyup', function (event) {
            _this.inputkeyup(event, index);
        });
        input.addEventListener('blur', function () {
            _this.inputBlur();
        });
        input.addEventListener('focus', function () {
            _this.inputFocus();
        });
        input.addEventListener('input', function (currentInput) {
            _this.onInput(currentInput, index);
        });
        input.addEventListener('keypress', function (event) {
            _this.validateNumbers(event, index);
        });
        input.addEventListener('keydown', function (event) {
            _this.validateOtherCharacters(event, index);
        });
    };
    BcInputTokenBehavior.prototype.initialFocus = function () {
        this.mySelf.querySelector("input[id='".concat(this._id, "-1']")).focus();
        this.getElementContainer().classList.add("".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_CONTAINER_INITIAL_FOCUS));
    };
    BcInputTokenBehavior.prototype.createLabel = function () {
        var label = document.createElement('label');
        label.setAttribute('class', 'bc-label-bottom-token');
        label.setAttribute('aria-label', this.getInfoMessage());
        label.innerText = this.getInfoMessage();
        this.mySelf.appendChild(label);
    };
    BcInputTokenBehavior.prototype.controlInputs = function () {
        var container = this.mySelf.querySelectorAll("input[id^='".concat(this._id, "']"));
        var values = '';
        var inputElements = Array.from(container);
        var isValid = false;
        for (var i = 0; i < inputElements.length; i++) {
            var element = inputElements[i];
            var preValid = element.validity;
            values += element.value;
            if (i == 0 && preValid.valid) {
                isValid = true;
            }
            else if (!preValid.valid && isValid) {
                isValid = false;
            }
            else if (preValid.valid && isValid) {
                isValid = true;
            }
            else {
                isValid = false;
            }
        }
        this.value = values;
        this.inputStatus = isValid;
    };
    BcInputTokenBehavior.prototype.removeAllValuesAndState = function () {
        if (this.mySelf) {
            var inputs = Array.from(this.mySelf.querySelectorAll('input'));
            inputs.forEach(function (input) {
                input.value = '';
                input.classList.remove(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_FILLED);
            });
            this.removeValid();
            this.inputStatus = false;
        }
    };
    BcInputTokenBehavior.prototype.changeStatus = function (newStatus) {
        this.removeError();
        this.disabledInputs(false);
        if (newStatus === 'error') {
            this.putError();
            this.mySelf.setAttribute('status', 'error');
        }
        else if (newStatus === 'disabled') {
            this.disabledInputs(true);
            this.mySelf.setAttribute('status', 'disabled');
            this.status = 'disabled';
        }
        else {
            this.status = 'default';
            this.mySelf.setAttribute('status', 'default');
        }
    };
    BcInputTokenBehavior.prototype.changeValuesEmitEvent = function () {
        if (this.outputValue) {
            this.outputValue(this.value);
        }
    };
    BcInputTokenBehavior.prototype.changeStatusEmitEvent = function () {
        if (this.outputStatus) {
            this.outputStatus(this.isValid);
        }
    };
    BcInputTokenBehavior.prototype.disabledInputs = function (isDisabled) {
        var inputs = Array.from(this.mySelf.querySelectorAll('input'));
        inputs.forEach(function (input) {
            input.disabled = isDisabled;
        });
    };
    BcInputTokenBehavior.prototype.setValue = function (value) {
        if (value) {
            var splitedValue = value.split('');
            var inputs_1 = Array.from(this.mySelf.querySelectorAll('input'));
            var inputPosition_1 = 0;
            splitedValue.forEach(function (digit) {
                var currentInput = inputs_1[inputPosition_1];
                currentInput.value = digit;
                inputPosition_1++;
                if (inputs_1[inputPosition_1]) {
                    inputs_1[inputPosition_1].focus();
                }
            });
            this.controlInputs();
            if (this.inputStatus) {
                this.putValid();
                this.changeValuesEmitEvent();
            }
            else {
                this.removeValid();
            }
            if ((!this.isValid && this.inputStatus) || (this.isValid && !this.inputStatus)) {
                this.isValid = this.inputStatus;
                this.changeStatusEmitEvent();
            }
        }
        else {
            this.removeAllValuesAndState();
        }
    };
    BcInputTokenBehavior.prototype.setStatus = function (newStatus) {
        this.changeStatus(newStatus);
        this.previousValue = newStatus === 'error' ? this.value : '';
        this.previousStatus = newStatus === 'error' ? newStatus : '';
    };
    BcInputTokenBehavior.prototype.setDisabledState = function (isDisabled) {
        this.setStatus(isDisabled ? 'disabled' : 'default');
    };
    BcInputTokenBehavior.prototype.preventCopyCutPaste = function () {
        var container = this.mySelf.querySelector(".".concat(bc_input_token_constants_1.BcInputTokenConstants.BC_INPUT_TOKEN_CONTAINER));
        var inputs = container.querySelectorAll(common_constants_1.BcCommonConstants.INPUT_TAG);
        inputs.forEach(function (char) {
            char.addEventListener(common_constants_1.BcCommonConstants.EVENT_PASTE, function (event) {
                event.preventDefault();
            });
            char.addEventListener(common_constants_1.BcCommonConstants.EVENT_COPY, function (event) {
                event.preventDefault();
            });
            char.addEventListener(common_constants_1.BcCommonConstants.EVENT_CUT, function (event) {
                event.preventDefault();
            });
        });
    };
    return BcInputTokenBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcInputTokenBehavior = BcInputTokenBehavior;
